import * as getCountryName from './get-country-name';
import * as searchCountry from './search-country';
import { groupCountriesByAlphabet } from './group-countries';

export const citizenshipLib = {
  ...getCountryName,
  ...searchCountry,
  groupCountriesByAlphabet,
};
